import { ca } from '@cian/analytics';

import { EAnalyticsKey } from '../../types/chatHint';
import { TSingleChatV2Response } from '../../types/chatList';
import { TGoogleAnalytics } from '../../types/openedChats';
import { IUserInChatListSchema } from '../../types/userData';

export function trackOpenNoLinksPopup() {
  ca('eventSite', {
    action: 'Open_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
  });
}
export function trackOpenForbiddenTextPopup() {
  ca('eventSite', {
    action: 'Open_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
  });
}

interface ITrackFirstMessageSentParams {
  ga: TGoogleAnalytics | undefined;
  users: TSingleChatV2Response['users'] | IUserInChatListSchema[] | undefined;
  offerId: number | undefined;
  agentId: number | undefined | null;
  userId: number;
  analyticsKey: EAnalyticsKey | null;
  pageTypeSource?: string;
  isEarlyAccess?: boolean;
  chatId?: string;
  contextToken?: string;
}

export function trackFirstMessageSent({
  ga,
  users = [],
  offerId,
  agentId,
  userId,
  analyticsKey,
  pageTypeSource,
  isEarlyAccess,
  chatId,
  contextToken,
}: ITrackFirstMessageSentParams) {
  const { products: gaProducts, source, sc, offersQty, mlSearchSessionGuid } = ga || {};
  //@ts-expect-error Другого способа получить информацию о странице нет
  const page = window.CianAnalytics?.service.config.page || {};

  // TODO: переписать логику используя роли, учесть, что у нас есть 3+ чаты
  const companion = users.find((user: { userId: number }) => user.userId !== userId);

  const products = gaProducts || [
    {
      id: offerId || agentId,
      offerType: offerId ? 'offer' : 'agent',
      ...(offerId ? {} : { extra: { recipientid: companion?.userId } }),
    },
  ];

  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'send_message',
    label: source,
    products,
    page: {
      ...page,
      extra: {
        owner_id: userId,
        questionName: analyticsKey,
        pageTypeSource,
        mlSearchSessionGuid,
        is_early_access: isEarlyAccess,
        chat_id: chatId,
        context_token: contextToken,
      },
      offersQty,
    },
    sc,
  });
}

interface ITrackFirstMessageWithBotSentParams {
  label?: string;
  opponentId?: number | null;
  ownerId?: number | null;
  analyticsKey: EAnalyticsKey | null;
  pageTypeSource?: string;
  botId: number | null;
}

export function trackFirstMessageWithBotSent({
  label,
  ownerId,
  opponentId,
  analyticsKey,
  pageTypeSource,
  botId,
}: ITrackFirstMessageWithBotSentParams) {
  //@ts-expect-error Другого способа получить информацию о странице нет
  const page = window.CianAnalytics?.service.config.page || {};

  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'send_message',
    label,
    useLastProducts: true,
    page: {
      ...page,
      extra: {
        owner_id: ownerId,
        opponent_id: opponentId,
        bot_id: botId,
        questionName: analyticsKey,
        pageTypeSource,
      },
    },
  });
}
